
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/donate-form",
      function () {
        return require("private-next-pages/community/donate-form.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/donate-form"])
      });
    }
  